import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const ModalReducer = (state = null, { type, payload }) => {
    switch (type) {
        case MultichainActionType.OPEN_MODAL: {
            return payload;
        }
        case MultichainActionType.CLOSE_MODAL: {
            return null;
        }
        default:
            return state;
    }
};
